import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../../App.css';
import '../Login/loginPage.css';
import { verifyPasswordToken, setPassword } from '../../services/api';

const SetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [username, setUsername] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [fadeIn, setFadeIn] = useState(false);

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });

  useEffect(() => {
    setFadeIn(true);

    if (!token) {
      setErrorMessage("Token manquant dans l'URL");
      setLoading(false);
      return;
    }

    const verifyToken = async () => {
      try {
        const data = await verifyPasswordToken(token);
        setTokenValid(true);
        setUsername(data.username);
      } catch (error) {
        const message = error.response?.data?.error || 'Token invalide ou expiré';
        setErrorMessage(message);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, [token]);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrorMessage('');
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage('Les mots de passe ne correspondent pas');
      return;
    }

    if (formData.password.length < 8) {
      setErrorMessage('Le mot de passe doit contenir au moins 8 caractères');
      return;
    }

    try {
      await setPassword(token, formData.password);
      setSuccessMessage('Mot de passe défini avec succès ! Redirection vers la connexion...');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      const message = error.response?.data?.error || 'Erreur lors de la définition du mot de passe';
      setErrorMessage(message);
    }
  };

  if (loading) {
    return (
      <div className={`login-container${fadeIn ? ' fade-in' : ''}`}>
        <p>Vérification du lien...</p>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className={`login-container${fadeIn ? ' fade-in' : ''}`}>
        <div>
          <h2>Lien invalide</h2>
          <p className="errorMessage">{errorMessage}</p>
          <p>
            <a href="/login">Retour à la connexion</a>
          </p>
        </div>
      </div>
    );
  }

  if (successMessage) {
    return (
      <div className={`login-container${fadeIn ? ' fade-in' : ''}`}>
        <div>
          <h2>Succès</h2>
          <p style={{ color: 'green' }}>{successMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`login-container${fadeIn ? ' fade-in' : ''}`}>
      <form onSubmit={handleSubmit}>
        <h2>Définir votre mot de passe</h2>
        <p>
          Compte : <strong>{username}</strong>
        </p>
        <div className="form-group">
          <label>Nouveau mot de passe :</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            minLength={8}
            required
          />
        </div>
        <div className="form-group">
          <label>Confirmer le mot de passe :</label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            minLength={8}
            required
          />
        </div>
        <button type="submit">Définir le mot de passe</button>
        {errorMessage && <p className="errorMessage">{errorMessage}</p>}
      </form>
    </div>
  );
};

export default SetPasswordPage;
